const initialState = {
  bool: false
}

const showEditEmployeeMessageReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SHOW_EDIT_EMPLOYEE_MESSAGE' : {
      return {
        ...state,
        bool: action.bool
      }
    }
    default: {
      return state
    }
  }
}

export default showEditEmployeeMessageReducer
